import { Navigate } from 'react-router-dom';
import { usePhoneVerified } from '@/hooks/usePhoneVerified';

interface Props {
  children: React.ReactNode;
}

/**
 * Wraps routes that require a verified phone number.
 * Redirects to /onboarding/basic-info (which resumes at its SMS Stage B) if phone is not yet verified.
 */
const PhoneVerifiedGuard = ({ children }: Props) => {
  const verified = usePhoneVerified();

  if (verified === null) {
    // Loading
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!verified) {
    // Direct route — basic-info resumes at its SMS Stage B ('sms-verify' is a
    // retired id kept only as a legacy redirect).
    return <Navigate to="/onboarding/basic-info" replace />;
  }

  return <>{children}</>;
};

export default PhoneVerifiedGuard;
